/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Case_Payment_Policy_UpfrontInputs */

const en_case_payment_policy_upfront = /** @type {(inputs: Case_Payment_Policy_UpfrontInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upfront: maximum discount of ${i?.value}%.`)
};

const pt_br2_case_payment_policy_upfront = /** @type {(inputs: Case_Payment_Policy_UpfrontInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À vista: desconto máximo de ${i?.value}%.`)
};

/**
* | output |
* | --- |
* | "Upfront: maximum discount of {value}%." |
*
* @param {Case_Payment_Policy_UpfrontInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_policy_upfront = /** @type {((inputs: Case_Payment_Policy_UpfrontInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Policy_UpfrontInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_policy_upfront(inputs)
	return pt_br2_case_payment_policy_upfront(inputs)
});